/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./fruitRush.vue?vue&type=template&id=40bb0cb9&scoped=true"
import script from "./fruitRush.vue?vue&type=script&lang=js"
export * from "./fruitRush.vue?vue&type=script&lang=js"
import style0 from "./fruitRush.vue?vue&type=style&index=0&id=40bb0cb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb0cb9",
  null
  
)

export default component.exports